import {DateTime} from 'luxon';

export class VehicleReleaseModalResult {
  constructor(
    public readonly vehicleReleaseDate: DateTime,
    public readonly vehicleReleasePerson: string
  ) {
  }
}
